module.exports = __webpack_public_path__ + "img/logo.3ea0c0d9.svg";